import { PermissiblePurposesListDocument, usePermissiblePurposeCreateMutation } from 'src/api';

import { useNotification } from '../app';

export const usePermissiblePurposeCreate = () => {
  const { createApolloContext } = useNotification();

  const [createPermissiblePurpose] = usePermissiblePurposeCreateMutation({
    context: createApolloContext({
      errorMessage: 'Failed to create Permissible Purpose',
      successMessage: 'Permissible Purpose successfully created',
    }),
    refetchQueries: [PermissiblePurposesListDocument],
  });

  return { createPermissiblePurpose };
};
